import { use_slice_ui } from '@/hooks/store/use_slices';
import { assert_not_null } from '@shared/asserts/utils_asserts';
import { FC, useEffect, useRef, useState } from 'react';
import { FN_CANVAS__apply_image_compare__base } from '../_methods/FN_CANVAS__apply_image_compare__base';
import { FN_CANVAS__apply_image_compare__slider } from '../_methods/FN_CANVAS__apply_image_compare__slider';
import { PROPS__draw_mode_params } from '../_methods/PROPS__draw_mode_params';

export interface PROPS {
  image_a: HTMLImageElement;
  image_b: HTMLImageElement;
}

export const IMAGE_COMPARE__mode_slider: FC<PROPS> = ({ image_a: image_a, image_b }) => {
  const { grid2d_image_compare__use_image_a_asperation_ratio } = use_slice_ui(['grid2d_image_compare__use_image_a_asperation_ratio']);

  /*
   *
   */

  const [position_split, set_position_split] = useState<number>(0.5);

  const ref__canvas = useRef<HTMLCanvasElement | null>(null);
  const ref__is_dragging = useRef<boolean>(false);

  /*
   *
   */

  // Draw canvas on update
  useEffect(() => {
    const canvas: HTMLCanvasElement | null = ref__canvas.current;
    if (!canvas) return;

    const ctx: CanvasRenderingContext2D | null = canvas.getContext('2d');
    assert_not_null(ctx);

    FN_CANVAS__apply_image_compare__base(canvas);

    const rect: DOMRect = canvas.getBoundingClientRect();

    const baseParams: PROPS__draw_mode_params = {
      ctx,
      width: rect.width,
      height: rect.height,
      image_a: image_a,
      image_b: image_b,
      fitAR: grid2d_image_compare__use_image_a_asperation_ratio,
    };

    FN_CANVAS__apply_image_compare__slider({ ...baseParams, position_split });
  }, [position_split, grid2d_image_compare__use_image_a_asperation_ratio, image_a, image_b]);

  /*
   *
   */

  // Pointer Interaction Handlers
  function on_pointer_move(e: React.PointerEvent<HTMLCanvasElement>): void {
    if (!ref__is_dragging.current) return;
    if (!ref__canvas.current) return;

    const rect: DOMRect = ref__canvas.current.getBoundingClientRect();
    const x: number = e.clientX - rect.left;
    const position_new: number = Math.max(0.02, Math.min(0.98, x / rect.width));

    set_position_split(position_new);
  }

  function on_pointer_down(e: React.PointerEvent<HTMLCanvasElement>): void {
    ref__is_dragging.current = true;
    on_pointer_move(e);
  }

  function on_pointer_up(): void {
    ref__is_dragging.current = false;
  }

  /*
   *
   */

  return (
    <div className="relative w-full h-full rounded-lg overflow-hidden border border-[#48ff84]/20 bg-[#050906]">
      <canvas
        ref={ref__canvas}
        onPointerDown={on_pointer_down}
        onPointerMove={on_pointer_move}
        onPointerUp={on_pointer_up}
        onPointerLeave={on_pointer_up}
        className="w-full h-full cursor-pointer touch-none"
      />
    </div>
  );
};
